import {
  Col,
  type ColProps,
  type FormItemProps,
  Input,
  InputNumber,
  type InputNumberProps,
  type InputProps,
  Select,
} from 'antd';
import { type TextAreaProps } from 'rc-textarea/lib/interface';
import { FC } from 'react';

import { type SelectProps } from '@components';

import * as S from './styled';

type CommonProps = {
  form: FormItemProps;
};

type WrapperProps = {
  span?: ColProps['span'];
};

type InputControlProps = CommonProps & {
  type: 'input';
  control?: InputProps;
};

type TextAreaControlProps = CommonProps & {
  type: 'textarea';
  control?: TextAreaProps;
};

type InputNumberControlProps = CommonProps & {
  type: 'input-number';
  control?: InputNumberProps;
};

type SelectControlProps = CommonProps & {
  type: 'select';
  control?: SelectProps;
};

type FormControlProps =
  | InputControlProps
  | InputNumberControlProps
  | TextAreaControlProps
  | SelectControlProps;

const FormControl: FC<FormControlProps> = ({ type, form, control }) => (
  <S.FormItem {...form}>
    {type === 'input' && <Input size="large" {...control} />}

    {type === 'input-number' && <InputNumber size="large" {...control} />}

    {type === 'textarea' && <Input.TextArea size="large" {...control} />}

    {type === 'select' && <Select size="large" showSearch {...control} />}
  </S.FormItem>
);

const ContactsWrapperFormControl: FC<FormControlProps & WrapperProps> = ({
  span,
  ...rest
}) => {
  if (span) {
    return (
      <Col span={span}>
        <FormControl {...rest} />
      </Col>
    );
  }

  return <FormControl {...rest} />;
};

export default ContactsWrapperFormControl;
